import React from 'react';
import { Map } from 'immutable';
import { bindActionCreators } from 'redux';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { Request } from '../../../core/comm/index';
import comm from '../../../core/comm/actions';
import qform from '../../../core/components/form/queries';
import View from '../../../components/View';
import ResetPasswordView from './ResetPassword';

const url = '/v1/pub/redefinir_password/:cid';

const applet = '/p/senha';
const views = {
  mudarSenha: `${applet}/redefinir/:cid`,
};

function resetPassword(data, cid) {
  return comm.post(
    Request({ data, view: views.mudarSenha, url, urlParams: Map({ cid }) }),
  );
}

function query(data) {
  return data;
}

function mapStateToProps(state) {
  return { formState: qform.queryData(state, views.mudarSenha, 'form', query) };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ resetPassword }, dispatch);
}

const ConnectedView = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ResetPasswordView);

export default (<Route
  exact
  path={views.mudarSenha}
  component={View.createRenderer({
    component: ConnectedView,
    applet,
    view: views.mudarSenha,
  })}
/>);
